import { sanitizeBoatFilename } from '../../sim/boat/index.ts';
import { confirmDialog, type ConfirmOptions } from '../editor/dialog.tsx';
import { setPanel } from '../panels.ts';

export { confirmDialog };
export type { ConfirmOptions };

/** Asks for a `boats/<name>.json` basename. Empty or invalid names cancel. */
export function promptBoatFilename(defaultValue: string): Promise<string | null> {
  return new Promise((resolve) => {
    const settle = (value: string | null): void => {
      setPanel('editorDialog', null);
      resolve(value);
    };

    setPanel('editorDialog', {
      title: 'Save boat',
      message:
        'Writes boats/<name>.json in this repo. Later Saves update that file without a dialog.',
      confirmLabel: 'Save',
      cancelLabel: 'Cancel',
      inputDefault: defaultValue.replace(/\.json$/i, ''),
      inputLabel: 'File name',
      onConfirm: (value) => settle(sanitizeBoatFilename(value)),
      onCancel: () => settle(null),
    });
  });
}
